<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ isGenerating
        ? 'Generating Test Cases'
        : (configs?.title || 'What type of test cases would you like to generate?') }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    [disabled]="isGenerating && !isProgressError"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body">

  <!-- Process logs state (replaces progress-bar popup) -->
  <div *ngIf="isGenerating" class="gtc-process">
    <div class="gtc-process-error-banner" *ngIf="isProgressError && (errorText || progressText)">
      <span class="gtc-process-error-label">Action Required:</span>
      <span class="gtc-process-error-message">{{ errorText || progressText }}</span>
    </div>

    <app-process-logs-loader
      [logs]="processLogs"
      [statusLabel]="processStatusLabel"
      [isActive]="isProcessActive"
      [isError]="isProgressError"
      [showLoader]="true"
    ></app-process-logs-loader>
  </div>

  <!-- Config form (hidden while generating) -->
  <ng-container *ngIf="!isGenerating">

    <!-- Error banner -->
    <div *ngIf="errorText" class="gtc-error" role="alert">{{ errorText }}</div>

    <!-- Functional Test Cases Section -->
    <div class="config-section">
      <div class="section-row">
        <div class="section-info">
          <span class="header-2">Functional Test Cases</span>
          <p class="general-text">
            Generate test cases to validate application functionality for smoke, sanity, or regression testing
          </p>
        </div>
        <div class="form-check form-switch mb-0">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="functionalEnabled"
            (change)="onFunctionalToggle()"
          />
        </div>
      </div>

      <div class="radio-group" *ngIf="functionalEnabled">
        <label class="general-text">
          Test type <span class="text-danger">*</span>
        </label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="testType"
            id="smokeTest"
            value="smoke"
            [(ngModel)]="selectedTestType"
          />
          <label class="general-text" for="smokeTest">
            Smoke Testing
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="testType"
            id="sanityTest"
            value="sanity"
            [(ngModel)]="selectedTestType"
          />
          <label class="general-text" for="sanityTest">
            Sanity Testing
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="testType"
            id="regressionTest"
            value="regression"
            [(ngModel)]="selectedTestType"
          />
          <label class="general-text" for="regressionTest">
            Regression Testing
          </label>
        </div>
      </div>
    </div>

    <!-- Non-functional Test Cases Section -->
    <div class="config-section">
      <div class="section-row">
        <div class="section-info">
          <span class="header-2">Non-functional Test Cases</span>
          <p class="general-text">
            Generate test cases to validate application performance, security, usability, reliability, and other quality attributes
          </p>
        </div>
        <div class="form-check form-switch mb-0">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="nonFunctionalSwitch"
            [(ngModel)]="nonFunctionalEnabled"
            (change)="onNonFunctionalToggle()"
          />
        </div>
      </div>
    </div>

  </ng-container>

</div>

<div class="modal-footer" *ngIf="!isGenerating || isProgressError">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      *ngIf="!isGenerating"
      class="btn-accello-primary-light"
      (click)="onGenerate()"
      [disabled]="!canGenerate"
    >
      {{ configs?.saveBtnText || 'Generate' }}
    </button>
  </div>
</div>
